export * from './role.types'
export * from './userlist.types'
export * from './auth.types'
export * from './programDetailsTypes'
export * from './productPricing.types'
export * from './ndcCodes.types'
export * from './layoutBuilder.types'
export * from './entity.types'
export * from './macros.type'
export * from './templateManager.types'
export * from './approved.types'
export * from './manualCommunication.types'
export * from './programWorkingHours.types'
export * from './tableColumn.types'
export * from './documentTemplate.types'
export * from './clientPermissions.types'
export * from './view360.types'
export * from './intakequeue.types'
export * from './multiProductEnrollment.types'
export * from './error.type'
export * from './queueCreation.types'
export * from './toast.types'
export * from './audit.types'
export * from './notifications.types'
export * from './userAccessControl.types'
export * from './permissionAssignment.types'
export * from './dashboardConfig.types'
export * from './workflow'
export * from './correspondenceLogs.types'
export * from './reports.types'
export * from './maxRTE.types'
export * from './experian.types'
export * from './mec.types'
export * from './clientDropdown.types'
export * from './ruleConfig.types'
export * from './userPreferences.types'
export * from './permissions.types'
export * from './awsCall.types'
export * from './ocr.types'
export * from './urgencyIndex.types'
export * from './consentConfigration.types'
export interface DataTypeStore {
  [key: string]: string | number | boolean | string[] | number[]
}

export interface DropdownOptionsType {
  label: string
  value: string
}

export interface DropdownOptionsTypeNumber {
  label: string
  value: number
}

export interface DataTypeStoreExtended {
  [key: string]:
    | string
    | number
    | boolean
    | string[]
    | number[]
    | DataTypeStore[]
    | DataTypeStore
}

export interface SearchFilterType {
  fields: string[]
  search_criteria: {
    search_key: string
    search_value: string[]
    operator: string
  }[]
}

export enum SORT_KEYS {
  Asc = 'asc',
  Desc = 'desc',
  Disabled = 'disabled',
}

interface GlobalVariables {
  config: {
    case_id: string
    case_status: string
  }
  add_task: {
    entity_id: string
    layout_id: string
    entity_name: string
  }
  entities: {
    [key: string]: {
      entity_id: string
      entity_name: string
    }
  }
  entity_id: string
  left_split: {
    edit_layout_id: string
    view_layout_id: string
  }
  entity_name: string
  id_field_name: string
  inherited_variables: {
    service_id: number
    record_status: string
    show_mi_popup: boolean
    case_status_id: number
  }
  associated_variables: {
    [key: string]: {
      entity_id: string
      parent_entity: string
    }
  }
}

export interface WorkflowItem {
  id: number
  uid: string
  name: string
  description: string
  record_status: string
  global_variables: GlobalVariables
}

export enum LoginTypeEnum {
  LOGIN = 'LOGIN',
  REFRESH = 'REFRESH',
  UNAUTHORIZED = 'UNAUTHORIZED',
  USER_INITIATED_LOGOUT = 'USER_INITIATED_LOGOUT',
  ADMIN_FORCED_LOGOUT = 'ADMIN_FORCED_LOGOUT',
  SESSION_INACTIVITY_LOGOUT = 'SESSION_INACTIVITY_LOGOUT',
  /** Max session lifetime reached; user must sign in again. */
  MANDATORY_RELOGIN_LOGOUT = 'MANDATORY_RELOGIN_LOGOUT',
}

export enum UserTypeEnum {
  AGENT = 'AGENT',
  ADMIN = 'ADMIN',
}

export interface ApiValidationError extends Error {
  statusCode: number
  code: string
  fields: string[]
  endpoint: string
  method: string
  initiator: string
}
